import { ComponentRenderer, Page } from "@ludens-reklame/rubics-v3-react/page";
import { Store } from "@ludens-reklame/rubics-v3-sdk/store/types";
import { ModalProvider } from "@ludens-reklame/react-modal";
import { AppProvider } from "./context/app-context.js";

export const App: React.FC<{ store: Store; renderer: ComponentRenderer }> = ({
  store,
  renderer,
}) => {
  return (
    <Page store={store} useCartContext renderComponent={renderer}>
      {({ header, main, footer }) => {
        return (
          <ModalProvider>
            <AppProvider>
              {header}
              <main>{main}</main>
              {footer}
            </AppProvider>
          </ModalProvider>
        );
      }}
    </Page>
  );
};
